module.exports = __webpack_public_path__ + "img/btn-sortear-vacio.f4c15c3e.png";